/* Copyright (c) 2020-present CloudIO Inc */

import { Page, Platform } from 'componentregistry';
import Store from '../../../../../../store/Store';
import gridWithSearchAndEditForm from './GridWithSearchAndEditForm';
import Form from './Form';
import gridWithSearchAndEditFormInsideTabPanel from './GridWithSearchAndEditFormInsideTabPanel';

export type GeneratePage = (props: {
  platform: Platform;
  store: Store<unknown>;
  appUid: string;
  pageId: string;
}) => Promise<Page>;

export interface DSTemplate {
  name: string;
  pageId: string;
  height?: number;
  generatePage: GeneratePage;
}

export const ds_registry: DSTemplate[] = [
  {
    name: 'Grid with Smart Search & Edit Form',
    generatePage: gridWithSearchAndEditForm,
    pageId: 'gridWithSearchAndEditForm',
  },
  {
    name: 'Dashboard, List & Edit Tabs',
    generatePage: gridWithSearchAndEditFormInsideTabPanel,
    pageId: 'gridWithSearchAndEditFormInsideTabPanel',
  },
  {
    name: 'Form',
    generatePage: Form,
    pageId: 'form',
  },
];
